import React from "react";
import "../App.css";

import { Footer } from "../Components/Footer";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { FirstSlide } from "../Components/FirstSlide";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const Home = () => {
  const [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <div className="App">
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            paddingTop: "210px",
          }}
        >
          <DotLoader
            color={color}
            loading={loading}
            cssOverride={override}
            size={100}
          />
        </div>
      ) : (
        <>
          <FirstSlide />
          <Footer />
        </>
      )}
    </div>
  );
};
